// Dealer navigation helper for paginating dealer lists

const INCREMENT_SIZE = 4;

interface DealerNavigatorState {
  visibleCount: number;
  dealers: any[];
  hasCompletedCycle: boolean;
}

const dealerNavigatorHelper = (function() {
  let visibleCount = 0;
  let dealers: any[] = [];
  let hasCompletedCycle = false;

  return {
    init: function(dealersArray: any[]): void {
      dealers = [...dealersArray];
      visibleCount = 0;
      hasCompletedCycle = false;
    },
    
    getNext: function(): any[] {
      if (hasCompletedCycle) {
        this.reset();
        return this.getNext();
      }

      const newCount = visibleCount + INCREMENT_SIZE;
      
      if (newCount >= dealers.length) {
        visibleCount = dealers.length;
        hasCompletedCycle = true;
      } else {
        visibleCount = newCount;
      }
      
      return dealers.slice(0, visibleCount);
    },
    
    getPrevious: function(): any[] {
      hasCompletedCycle = false;
      visibleCount = Math.max(0, visibleCount - INCREMENT_SIZE);
      return dealers.slice(0, visibleCount);
    },
    
    reset: function(): void {
      visibleCount = 0;
      hasCompletedCycle = false;
    },
    
    getCurrentDealers: function(): any[] {
      return dealers.slice(0, visibleCount);
    },
    
    hasMoreDealers: function(): boolean {
      // Only returns false when we've shown all dealers AND haven't reset yet
      return !(hasCompletedCycle && visibleCount === dealers.length);
    },
    
    hasCompletedCycle: function(): boolean {
      return hasCompletedCycle;
    },
    
    getVisibleCount: function(): number {
      return visibleCount;
    }
  };
})();

export { dealerNavigatorHelper };
